import { render, staticRenderFns } from "./SliceTileHero.vue?vue&type=template&id=481792e9&lang=pug&"
import script from "./SliceTileHero.vue?vue&type=script&lang=js&"
export * from "./SliceTileHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports